import {db} from './index';
import {collection, getDocs, query, where} from 'firebase/firestore';
import {snapShotToArray} from './common';

const metaCategoryCollection = collection(db, 'meta-categories');

export const getAllMetaCategories = async () => {
  const array = snapShotToArray(await getDocs(query(metaCategoryCollection)));

  return array.map(value => {
    const {updatedAt, ...other} = value;
    return other;
  });
};

export const getMetaCategory = async (url) => {
  const array = snapShotToArray(await getDocs(query(metaCategoryCollection, where('url', '==', url)))) || [];

  return array.map(value => {
    const {updatedAt, ...other} = value;
    return other;
  })[0];
};
